import jquery from 'jquery';
import 'jquery.transit';
import 'jquery-easing';
import 'es6-promise/auto';

window.$ = jquery;
window.jQuery = jquery;

import owd from 'owd/owd';
import 'app/components/img-load';
import 'app/components/form';
import 'app/components/slider';
import 'app/components/scroll-top';
import 'app/components/menu-toggle';
import 'app/components/nav-toggle';
import 'app/components/inview';

// import 'app/components/fullpage-section';
// import 'app/components/fullpage-container';
import 'app/components/submenu';
import 'app/components/arrow';
// import 'app/components/is-submenu';
import 'app/components/play-video';
import 'app/components/submenu-appear';
import 'app/components/fix100vh';
import 'app/components/select';


import DefaultResolver from 'app/ajax/default-resolver';
import LoadMoreResolver from 'app/ajax/load-more-resolver';
import CategoriesResolver from 'app/ajax/categories-resolver';

import Ajax from 'owd/module/ajax';
// import FullPage from 'owd/module/fullpage';
// import ScrollbarPlaceholder from 'owd/module/scrollbar-placeholder';

const app = new owd.App();

// app.use('scrollbarPlaceholder', ScrollbarPlaceholder);
// app.use('fullpage', FullPage);
app.use('ajax', Ajax)
    .registerDefaultResolver(DefaultResolver)
    .registerResolver('load-more', LoadMoreResolver)
    .registerResolver('categories', CategoriesResolver);

app.run();
